import { Theme } from "../designTokens";

type Color = "brand" | "accent" | "auxiliary" | "gray";

export const mapBadgeColorToTheme = (color: Color, theme: Theme) => {
  switch (color) {
    case "auxiliary":
      return theme.palette.auxiliary[600];
    case "accent":
      return theme.palette.accent[600];
    case "gray":
      return theme.palette.gray[400];
    default:
      return theme.palette.brand[600];
  }
};

export const mapWrapColorToTheme = (color: Color, theme: Theme) => {
  switch (color) {
    case "auxiliary":
      return theme.palette.auxiliary[700];
    case "accent":
      return theme.palette.accent[700];
    case "gray":
      return theme.palette.gray[400];
    default:
      return theme.palette.brand[900];
  }
};
